import React from 'react'

export default ({ ...props }) => (
  <svg width='22' height='21' viewBox='0 0 22 21' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M20.35 1.63921H17.6V1.08921C17.6 0.785607 17.3536 0.539207 17.05 0.539207C16.7464 0.539207 16.5 0.785607 16.5 1.08921V1.63921H12.65C12.3464 1.63921 12.1 1.88561 12.1 2.18921C12.1 2.49281 12.3464 2.73921 12.65 2.73921H16.5V4.38921C16.5 4.69281 16.7464 4.93921 17.05 4.93921C17.3536 4.93921 17.6 4.69281 17.6 4.38921V2.73921H20.35C20.6536 2.73921 20.9 2.98561 20.9 3.28921V6.03921H14.85C14.5464 6.03921 14.3 6.28561 14.3 6.58921C14.3 6.89281 14.5464 7.13921 14.85 7.13921H20.9V18.6892C20.9 18.9928 20.6536 19.2392 20.35 19.2392H1.65C1.3464 19.2392 1.1 18.9928 1.1 18.6892V7.13921H6.05C6.3536 7.13921 6.6 6.89281 6.6 6.58921C6.6 6.28561 6.3536 6.03921 6.05 6.03921H1.1V3.28921C1.1 2.98561 1.3464 2.73921 1.65 2.73921H4.4V4.38921C4.4 4.69281 4.6464 4.93921 4.95 4.93921C5.2536 4.93921 5.5 4.69281 5.5 4.38921V2.73921H8.25C8.5536 2.73921 8.8 2.49281 8.8 2.18921C8.8 1.88561 8.5536 1.63921 8.25 1.63921H5.5V1.08921C5.5 0.785607 5.2536 0.539207 4.95 0.539207C4.6464 0.539207 4.4 0.785607 4.4 1.08921V1.63921H1.65C0.7403 1.63921 0 2.37951 0 3.28921V18.6892C0 19.5989 0.7403 20.3392 1.65 20.3392H20.35C21.2597 20.3392 22 19.5989 22 18.6892V3.28921C22 2.37951 21.2597 1.63921 20.35 1.63921Z'
      fill='#0D0D0D'
    />
    <path
      d='M4.95 17.0392H3.85C3.5464 17.0392 3.3 16.7928 3.3 16.4892C3.3 16.1856 3.5464 15.9392 3.85 15.9392H4.95C5.2536 15.9392 5.5 16.1856 5.5 16.4892C5.5 16.7928 5.2536 17.0392 4.95 17.0392Z'
      fill='#0D0D0D'
    />
    <path
      d='M8.25 17.0392H7.15C6.8464 17.0392 6.6 16.7928 6.6 16.4892C6.6 16.1856 6.8464 15.9392 7.15 15.9392H8.25C8.5536 15.9392 8.8 16.1856 8.8 16.4892C8.8 16.7928 8.5536 17.0392 8.25 17.0392Z'
      fill='#0D0D0D'
    />
    <path
      d='M11.55 17.0392H10.45C10.1464 17.0392 9.9 16.7928 9.9 16.4892C9.9 16.1856 10.1464 15.9392 10.45 15.9392H11.55C11.8536 15.9392 12.1 16.1856 12.1 16.4892C12.1 16.7928 11.8536 17.0392 11.55 17.0392Z'
      fill='#0D0D0D'
    />
    <path
      d='M14.85 17.0392H13.75C13.4464 17.0392 13.2 16.7928 13.2 16.4892C13.2 16.1856 13.4464 15.9392 13.75 15.9392H14.85C15.1536 15.9392 15.4 16.1856 15.4 16.4892C15.4 16.7928 15.1536 17.0392 14.85 17.0392Z'
      fill='#0D0D0D'
    />
    <path
      d='M18.15 17.0392H17.05C16.7464 17.0392 16.5 16.7928 16.5 16.4892C16.5 16.1856 16.7464 15.9392 17.05 15.9392H18.15C18.4536 15.9392 18.7 16.1856 18.7 16.4892C18.7 16.7928 18.4536 17.0392 18.15 17.0392Z'
      fill='#0D0D0D'
    />
    <path
      d='M4.95 14.8392H3.85C3.5464 14.8392 3.3 14.5928 3.3 14.2892C3.3 13.9856 3.5464 13.7392 3.85 13.7392H4.95C5.2536 13.7392 5.5 13.9856 5.5 14.2892C5.5 14.5928 5.2536 14.8392 4.95 14.8392Z'
      fill='#0D0D0D'
    />
    <path
      d='M8.25 14.8392H7.15C6.8464 14.8392 6.6 14.5928 6.6 14.2892C6.6 13.9856 6.8464 13.7392 7.15 13.7392H8.25C8.5536 13.7392 8.8 13.9856 8.8 14.2892C8.8 14.5928 8.5536 14.8392 8.25 14.8392Z'
      fill='#0D0D0D'
    />
    <path
      d='M11.55 14.8392H10.45C10.1464 14.8392 9.9 14.5928 9.9 14.2892C9.9 13.9856 10.1464 13.7392 10.45 13.7392H11.55C11.8536 13.7392 12.1 13.9856 12.1 14.2892C12.1 14.5928 11.8536 14.8392 11.55 14.8392Z'
      fill='#0D0D0D'
    />
    <path
      d='M14.85 14.8392H13.75C13.4464 14.8392 13.2 14.5928 13.2 14.2892C13.2 13.9856 13.4464 13.7392 13.75 13.7392H14.85C15.1536 13.7392 15.4 13.9856 15.4 14.2892C15.4 14.5928 15.1536 14.8392 14.85 14.8392Z'
      fill='#0D0D0D'
    />
    <path
      d='M18.15 14.8392H17.05C16.7464 14.8392 16.5 14.5928 16.5 14.2892C16.5 13.9856 16.7464 13.7392 17.05 13.7392H18.15C18.4536 13.7392 18.7 13.9856 18.7 14.2892C18.7 14.5928 18.4536 14.8392 18.15 14.8392Z'
      fill='#0D0D0D'
    />
    <path
      d='M4.95 12.6392H3.85C3.5464 12.6392 3.3 12.3928 3.3 12.0892C3.3 11.7856 3.5464 11.5392 3.85 11.5392H4.95C5.2536 11.5392 5.5 11.7856 5.5 12.0892C5.5 12.3928 5.2536 12.6392 4.95 12.6392Z'
      fill='#0D0D0D'
    />
    <path
      d='M8.25 12.6392H7.15C6.8464 12.6392 6.6 12.3928 6.6 12.0892C6.6 11.7856 6.8464 11.5392 7.15 11.5392H8.25C8.5536 11.5392 8.8 11.7856 8.8 12.0892C8.8 12.3928 8.5536 12.6392 8.25 12.6392Z'
      fill='#0D0D0D'
    />
    <path
      d='M11.55 12.6392H10.45C10.1464 12.6392 9.9 12.3928 9.9 12.0892C9.9 11.7856 10.1464 11.5392 10.45 11.5392H11.55C11.8536 11.5392 12.1 11.7856 12.1 12.0892C12.1 12.3928 11.8536 12.6392 11.55 12.6392Z'
      fill='#0D0D0D'
    />
    <path
      d='M14.85 12.6392H13.75C13.4464 12.6392 13.2 12.3928 13.2 12.0892C13.2 11.7856 13.4464 11.5392 13.75 11.5392H14.85C15.1536 11.5392 15.4 11.7856 15.4 12.0892C15.4 12.3928 15.1536 12.6392 14.85 12.6392Z'
      fill='#0D0D0D'
    />
    <path
      d='M18.15 12.6392H17.05C16.7464 12.6392 16.5 12.3928 16.5 12.0892C16.5 11.7856 16.7464 11.5392 17.05 11.5392H18.15C18.4536 11.5392 18.7 11.7856 18.7 12.0892C18.7 12.3928 18.4536 12.6392 18.15 12.6392Z'
      fill='#0D0D0D'
    />
    <path
      d='M8.25 10.4392H7.15C6.8464 10.4392 6.6 10.1928 6.6 9.88921C6.6 9.58561 6.8464 9.33921 7.15 9.33921H8.25C8.5536 9.33921 8.8 9.58561 8.8 9.88921C8.8 10.1928 8.5536 10.4392 8.25 10.4392Z'
      fill='#0D0D0D'
    />
    <path
      d='M11.55 10.4392H10.45C10.1464 10.4392 9.9 10.1928 9.9 9.88921C9.9 9.58561 10.1464 9.33921 10.45 9.33921H11.55C11.8536 9.33921 12.1 9.58561 12.1 9.88921C12.1 10.1928 11.8536 10.4392 11.55 10.4392Z'
      fill='#0D0D0D'
    />
    <path
      d='M14.85 10.4392H13.75C13.4464 10.4392 13.2 10.1928 13.2 9.88921C13.2 9.58561 13.4464 9.33921 13.75 9.33921H14.85C15.1536 9.33921 15.4 9.58561 15.4 9.88921C15.4 10.1928 15.1536 10.4392 14.85 10.4392Z'
      fill='#0D0D0D'
    />
    <path
      d='M18.15 10.4392H17.05C16.7464 10.4392 16.5 10.1928 16.5 9.88921C16.5 9.58561 16.7464 9.33921 17.05 9.33921H18.15C18.4536 9.33921 18.7 9.58561 18.7 9.88921C18.7 10.1928 18.4536 10.4392 18.15 10.4392Z'
      fill='#0D0D0D'
    />
    <path
      d='M13.0394 5.64981C12.8249 5.43531 12.4762 5.43531 12.2617 5.64981L11.0011 6.91041V2.18811C11.0011 1.88451 10.7547 1.63811 10.4511 1.63811C10.1475 1.63811 9.90112 1.88451 9.90112 2.18811V6.91041L8.64052 5.64981C8.42602 5.43531 8.07732 5.43531 7.86282 5.64981C7.64832 5.86431 7.64832 6.21301 7.86282 6.42751L10.0628 8.62751C10.1706 8.73531 10.3114 8.78811 10.4522 8.78811C10.593 8.78811 10.7338 8.73421 10.8416 8.62751L13.0416 6.42751C13.2561 6.21301 13.2561 5.86431 13.0416 5.64981H13.0394Z'
      fill='#0D0D0D'
    />
  </svg>
)
